import { Badge, Group } from '@mantine/core';
import React from 'react';

import { Component } from 'types';

type ComponentListProps = {
  components: (Component | string)[];
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

export function ComponentList({ components, size = 'sm' }: ComponentListProps) {
  return (
    <Group spacing="xs">
      {components.map((component) => {
        const componentName = typeof component === 'string' ? component : component.name;
        const componentId = typeof component === 'string' ? component : component._id;
        return (
          <Badge key={componentId} size={size} variant="outline">
            {componentName}
          </Badge>
        );
      })}
    </Group>
  );
}
